import { render, staticRenderFns } from "./TbodyReportByAgeAndWeek.vue?vue&type=template&id=25a4593a"
import script from "./TbodyReportByAgeAndWeek.vue?vue&type=script&lang=js"
export * from "./TbodyReportByAgeAndWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports